/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import SendPaymentLinksContent from './SendPaymentLinksContent';
import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import { useSendPaymentLinks } from '../../hooks/useSendPaymentLinks';

const SendPaymentLinksModal = ({
  order,
  platform,
  onSendPaymentLink
}) => {
  const { t } = useTranslation('Inbox');
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch({
      type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR
    });
  };

  const {
    paymentMethods,
    toggleMethod,
    handleOnSendPaymentLink,
    saving,
    selectedPaymentMethods
  } = useSendPaymentLinks({ order, platform, onSendPaymentLink, onClose });


  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('sendPaymentLinks.title')}
        closeAction={onClose}
        submitAction={handleOnSendPaymentLink}
        submitLabel={t('sendPaymentLinks.sendLink')}
        loading={saving}
        disabled={!selectedPaymentMethods.length}
      >
        <SendPaymentLinksContent
          order={order}
          platform={platform}
          paymentMethods={paymentMethods}
          onToggle={toggleMethod}
        />
      </RightModalLayout>
    </div>
  );
};

export default SendPaymentLinksModal;

